<template>
  <div
    id="customer-details"
    :class="{'dense': dense}"
    v-if="isPermittedAll([
      'CustomersGetByID'
    ])">
    <!-- Status -->
    <v-row>
      <v-col>
        <label>Status:</label>
        <b
          v-if="customer.SupportRenewalDeclined"
          class="error--text">
          Support Declined
        </b>
        <span
          v-else>
          Agrees to Support
        </span>
      </v-col>
    </v-row>
    <!-- / Status -->

    <!-- Address -->
    <v-row>
      <v-col>
        <label>Address:</label>
        <div>
          {{customer.CustomerAddress1}}
        </div>
        <div v-if="customer.CustomerAddress2">
          {{customer.CustomerAddress2}}
        </div>
        <div>
          {{customer.CustomerCity}},
          {{customer.CustomerState}}
          {{customer.CustomerZipCode}}
        </div>
      </v-col>
    </v-row>
    <!-- / Address -->

    <!-- Phone -->
    <v-row>
      <v-col class="pt-0">
        <label>Customer Phone:</label>
        <div
          v-if="customer.CustomerPhone1
            || customer.CustomerPhone2">
          <a
            :href="`tel:${customer.CustomerPhone1}`"
            target="_blank">
            {{customer.CustomerPhone1}}
          </a>
          <br>
          <a
            v-if="customer.CustomerPhone2"
            :href="`tel:${customer.CustomerPhone2}`"
            target="_blank">
            {{customer.CustomerPhone2}}
          </a>
        </div>
        <div v-else>N/A</div>
      </v-col>
    </v-row>
    <!-- / Phone -->

    <!-- Fax -->
    <v-row
      v-if="!hideFax">
      <v-col>
        <label>Fax:</label>
        <a
          v-if="customer.CustomerFax"
          :href="`tel:${customer.CustomerFax}`"
          target="_blank">
          {{customer.CustomerFax}}
        </a>
        <div v-else>N/A</div>
      </v-col>
    </v-row>
    <!-- / Fax -->

    <!-- Supervisor -->
    <v-row>
      <v-col>
        <label>Supervisor:</label>
        {{supervisor}}
      </v-col>
    </v-row>
    <!-- / Supervisor -->

    <!-- Email -->
    <v-row>
      <v-col>
        <label>Email:</label>
        <a
          :href="`mailto:${customer.CustomerEmail}`"
          target="_blank">
          {{customer.CustomerEmail || 'N/A'}}
        </a>
      </v-col>
    </v-row>
    <!-- / Email -->
  </div>
</template>

<script>
export default {
  name: 'CustomerDetails',
  props: [
    'customer',
    'dense',
    'hideFax',
  ],
  computed: {
    supervisor() {
      let str = 'N/A';

      if (this.customer.SupervisorEmployee) {
        str = this.customer.SupervisorEmployee.EmployeeName;
      }

      return str;
    },
  },
};
</script>

<style lang="scss">
#customer-details {
  &.dense {
    .col {
      padding-top: 0;
      padding-bottom: 8px;

      > label {
        font-weight: 300;
        margin-bottom: 0;
      }
    }
  }
}
</style>
